import React, { useCallback } from "react";
import Dropdown from "rsuite/esm/Dropdown";
import IconButton from "rsuite/esm/IconButton";
import Whisper from "rsuite/esm/Whisper";
import Popover from "rsuite/esm/Popover";
import { BsThreeDotsVertical } from "react-icons/bs";

const ContactsActionColumn = ({ value, setActionColData }) => {

    /* ------------------ Actions ------------------ */


    const handelLoginToAccount = useCallback((value) => {

        const LoginToAccount = {
            title: `Login To Account`,
            confirmText: `Are you sure you want to log in to the account?`,
            // product_key: productKey,
            enterprise_api_gateway_url: value.enterprise_api_gateway_url ? value.enterprise_api_gateway_url : "https://cms.muvi.com",
            encrypted_password: value.encrypted_password || "",
            email: value.email || "",
            store_id: "",
            isMuvi5: !isNaN(value.customer_id) && !isNaN(parseFloat(value.customer_id)),
            customer_id: value.customer_id || "",
            mautic_id: value.mautic_id || "",
            studio_id: value.customer_id || ""
        };

        setActionColData((prevState) => ({
            ...prevState,
            LoginToAccount,
            openModal: "loginToAccount"
        }));
    }, []);

    /* ------------------ Render Dropdown Items ------------------ */


    return (
        <div className="deals-action-column">
            <Whisper
                placement="bottomEnd"
                trigger="click"
                container={() => document.body}
                speaker={
                    <Popover full>
                        <Dropdown.Menu>
              {value.customer_id && (
                                <Dropdown.Item onClick={() => handelLoginToAccount(value)}>
                                    Login To Account
                                </Dropdown.Item>
              )}
                        </Dropdown.Menu>
                    </Popover>
                }
            >
                <IconButton icon={<BsThreeDotsVertical />} appearance="subtle" size="sm" />
            </Whisper>
        </div>
    );
};

export default ContactsActionColumn;


// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ContactsActionColumn.js